import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ColumnFilterPopComponent } from '../column-filter-pop/column-filter-pop.component';
import { columnFilter } from '../../shared/misc-classes';

@Component({
  selector: 'material-column-filter',
  templateUrl: './material-column-filter.component.html',
  styleUrls: ['./material-column-filter.component.css']
})
export class MaterialColumnFilterComponent implements OnInit {

  @Input() colName:string;
  @Input() listItems:Array<columnFilter>;
  @Output() popClosed:EventEmitter<void> = new EventEmitter<void>();

  constructor(private _popBox: MatBottomSheet) { }

  ngOnInit() {
  }

  openFilterView(){
    let _sheetRef:MatBottomSheetRef = this._popBox.open(ColumnFilterPopComponent)
    _sheetRef.instance.colName = this.colName;
    _sheetRef.instance.listItems = this.listItems;
    _sheetRef.instance.closeRequest.subscribe(() => {
      _sheetRef.dismiss();
    })

    _sheetRef.afterDismissed().subscribe((_chk) => {
      //
      this.popClosed.emit();
      //console.log(_chk);
    })
  }

  closeFilterView(event: MouseEvent): void {
    this._popBox.dismiss();
    event.preventDefault();
  }
}
 